module.exports = __webpack_public_path__ + "img/bingo_ball-20.a00b3097.png";